/**
 * Devuelve el valor del atributo si lo encuentra en el mismo elemento o en algún padre hasta el maximo.
 *
 * @param {HTMLElement} elem el target desde el cual se busca
 * @param {string} attr el nombre del atributo
 * @param {object} options Opciones para controlar hasta donde busca,...
 * @returns {string|null} Devuelve null si no encontrado
 */
export function findAttribute(elem, attr, options = {}) {
  const { parent = null, max = 10 } = options;

  attr = attr.replace('data-', '');

  let counter = max;
  let res = null;
  const dataAttr = `data-${attr}`;

  while (elem && counter && elem !== parent && !res) {
    counter--;
    res = elem.getAttribute(attr) || elem.getAttribute(dataAttr);
    elem = elem.parentElement;
  }
  return res;
}
